import React, { useState, useEffect } from "react";
import sanityClient from "../client";
import {
  FaSpotify,
  FaApple,
  FaYoutube,
  FaGlobe,
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";
import "./styles/AdvisoryBoard.scss";

const AdvisoryBoard = () => {
  const [advisoryBoard, setAdvisoryBoard] = useState([]);
  const [activeTab, setActiveTab] = useState("artist");
  const [visibleDescriptions, setVisibleDescriptions] = useState({});

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "advisoryBoard"]{
          _id,
          name,
          description,
          "photoUrl": photo.asset->url,
          socialLinks,
          category
        }`
      )
      .then((data) => setAdvisoryBoard(data))
      .catch(console.error);
  }, []);

  const toggleDescription = (id) => {
    setVisibleDescriptions((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const icons = {
    website: <FaGlobe />,
    spotify: <FaSpotify />,
    appleMusic: <FaApple />,
    youtube: <FaYoutube />,
    linkedin: <FaLinkedin />,
    facebook: <FaFacebook />,
    instagram: <FaInstagram />,
    twitter: <FaTwitter />,
    
  };

  const filteredBoard = advisoryBoard.filter(
    (member) => member.category === activeTab
  );

  return (
    <div className="advisory-board">
      <h1>Advisory Board & Mentors</h1>
      <div className="tabs">
        <button
          className={activeTab === "artist" ? "active" : ""}
          onClick={() => setActiveTab("artist")}
        >
          Artists
        </button>
        <button
          className={activeTab === "boardMember" ? "active" : ""}
          onClick={() => setActiveTab("boardMember")}
        >
          Board Members
        </button>
      </div>
      <div className="advisory-grid">
        {filteredBoard.map((member) => (
          <div key={member._id} className="advisory-card">
            <img
              src={member.photoUrl}
              alt={member.name}
              className="advisory-photo"
            />
            {!visibleDescriptions[member._id] && (
              <h3 className="advisory-name">{member.name}</h3>
            )}
            <button
              className="toggle-description-btn"
              onClick={() => toggleDescription(member._id)}
            >
              {visibleDescriptions[member._id]
                ? "Hide Description"
                : "View Description"}
            </button>
            {visibleDescriptions[member._id] && (
              <div className="advisory-description-scrollable">
                <p className="advisory-description">{member.description}</p>
              </div>
            )}
            <div className="social-links">
              {member.socialLinks &&
                member.socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    {icons[link.platform]}
                  </a>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvisoryBoard;
